let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("cJVIa")).then(() => parcelRequire('9KRMJ'));